module.exports = require("@files-stack/core");